module.exports = {
  1: {
    // en
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  2: {
    // es
    edit: "Editar",
    collage: "Collage",
    design: "Diseño",
    features: "Características",
    languages: "Idioma",
    signIn: "Iniciar sesión",
    myAccount: "Mi Cuenta",
    message: "Mensaje",
    myWork: "Mi Trabajo",
    myPublicPortfolio: "Mi Carpeta Pública",
    logOut: "Cerrar Sesión"
  },
  3: {
    // pt
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  4: {
    // ru
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  5: {
    // fr
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  6: {
    // de
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  7: {
    // cn
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  8: {
    // tw
    edit: "Edit",
    collage: "Collage",
    design: "Design",
    features: "Features",
    languages: "Languages",
    signIn: "Sign in",
    myAccount: "My account",
    message: "Message",
    myWork: "My work",
    myPublicPortfolio: "My public portfolio",
    logOut: "Log out"
  },
  9: {
    // jp
    edit: "編集",
    collage: "コラージュ",
    design: "デザイン",
    features: "機能",
    languages: "言語",
    signIn: "ログイン",
    myAccount: "マイアカウント",
    message: "私のメッセージ",
    myWork: "自分の作品",
    myPublicPortfolio: "自分の公開ページ",
    logOut: "ログアウト"
  }
};
